import React from 'react';
import PropTypes from 'prop-types';

import LabeledTextInput from 'components/consumer/LabeledTextInput';

const LastNameField = ({
  value,
  error,
  isTouched,
  handleBlur,
  handleChange,
  ...props
}) => (
  <LabeledTextInput
    id="last_name"
    name="last_name"
    label="Last name *"
    onChange={handleChange}
    onBlur={handleBlur}
    value={value}
    autoComplete="family-name"
    data-xc="shipping-last-name-field"
    errorMessage={isTouched && error ? error : null}
    required
    aria-required
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  />
);

LastNameField.propTypes = {
  error: PropTypes.string,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  isTouched: PropTypes.bool,
  value: PropTypes.string,
};

export default LastNameField;
